import { IWebinarRegisterOptions, IMeetingRegisterOptions } from 'marketing-site/lib/zoom'

export default async function registerToWebinar({
  registerUrl,
  params,
}: {
  registerUrl: string
  params: IWebinarRegisterOptions | IMeetingRegisterOptions
}) {
  return await fetch(registerUrl, {
    method: 'post',
    body: JSON.stringify(params),
  }).then((res) => res.json())
}
